import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';
import DesktopMenu from './DesktopMenu';
import { Link } from 'react-router-dom';
import gif from '../images/spin.gif';

import img1 from '../images/group_4.jpg';
import img2 from '../images/trance_3.jpg';
import img3 from '../images/group_6.jpg';

const venues = [
  'MIX Brussels',
  'Bétonsalon, Paris',
  'GAK Bremen',
  'Recyclart, Brussels',
  'Zinneke, Brussels',
  'Kriekelaar, Brussels',
  'Semaine du Son Festival',
  'Fotograph Festival, Prague',
  'Borealis Festival, Bergen'
];

const Group = () => {
  return (
    <>
      <Navbar />
      <DeskWrap>
        <DesktopMenu />
        <Gif src={gif} alt="spinning icon" />

        <Wrapper>
          <Header>
            <H1>Group Hypnosis Sessions</H1>
            <Subhead>
              Guided trance journeys for rest, nervous system regulation, and collective renewal — held online
              and in person, in wellness studios, community spaces, and museums alike.
            </Subhead>

            <ButtonRow>
              <PrimaryButton href="mailto:spectralcenterhypnosis@gmail.com">
                Invite me to host a session
              </PrimaryButton>
            </ButtonRow>
          </Header>

          <Body>
            <Para>
              <Text>
                <p>
                  These sessions are a gentle, communal way to drop beneath the noise of the day and reconnect
                  with the body's intelligence.
                </p>
                <p>
                  I combine hypnotherapy techniques with voice, subtle sound, and a carefully paced narrative
                  that helps people settle into a restorative trance state — without needing to "perform" or
                  share personal details.
                </p>
                <p>
                  Think of it as a guided practice of deep listening: calming the nervous system, softening
                  mental loops, and creating space for pleasure, clarity, and inner trust to return.
                </p>
              </Text>
              <Img src={img1} alt="group hypnosis image 1" />
            </Para>

            <Section>
              <H2>Presented at</H2>
              <VenueList>
                {venues.map((v) => (
                  <VenueItem key={v}>{v}</VenueItem>
                ))}
                <VenueItem>and more</VenueItem>
              </VenueList>
            </Section>

             <Section>
              <H2>More group offerings</H2>
              <OfferingsList>
                <Link to="/trance">
                  <OfferingsItem>
                    <Strong>t.r.a.n.c.e community hypnosis</Strong>
                    An ongoing collaboration with sound artist Diana Duta, with monthly sessions in Brussels.
                  </OfferingsItem>
                </Link>

                <Link to="/workplace">
                  <OfferingsItem>
                    <Strong>Team / Workplace Sessions</Strong>
                    Designed to reduce stress and support focus and cohesion in professional environments.
                  </OfferingsItem>
                </Link>
              </OfferingsList>
            </Section>


            <Section>
              <H2>What it's like</H2>
              <TwoCol>
                <Card>
                  <CardTitle>Simple + accessible</CardTitle>
                  <CardText>
                    Participants sit or lie down. No prior hypnosis experience needed.
                    No one is singled out — it's a shared, guided journey.
                  </CardText>
                </Card>

                <Card>
                  <CardTitle>Grounding + imaginative</CardTitle>
                  <CardText>
                    A calm induction, body-based cues, and an evocative inner landscape.
                    You can keep it practical, poetic, mystical, or somewhere in-between.
                  </CardText>
                </Card>

                <Card>
                  <CardTitle>Collective rest</CardTitle>
                  <CardText>
                    The group field matters: people often report feeling held, soothed, and surprisingly
                    connected — even in silence.
                  </CardText>
                </Card>

                <Card>
                  <CardTitle>Afterglow integration</CardTitle>
                  <CardText>
                    We close gently, with time to reorient and integrate. Optional tea / journaling / quiet
                    hang afterward if your space supports it.
                  </CardText>
                </Card>
              </TwoCol>
            </Section>

            <Para>
              <Img src={img2} alt="group hypnosis image 2" />
              <Text>
                <H2>Good for</H2>
                <p>
                  Wellness centres and holistic studios. Yoga and somatics spaces. Community gatherings and
                  intimate events. Artist-run spaces and healing arts programs. Museums and festivals. Retreat
                  days — as an opening, a closing, or an evening wind-down.
                </p>

                <Note>
                  Sessions are trauma-informed and choice-based, designed to be supportive without pushing
                  anyone into disclosure.
                </Note>
              </Text>
            </Para>

            <Section>
              <H2>Session themes</H2>
              <OfferingsContainer>
                <OfferingsList>
                  <OfferingsItem>
                    <Strong>Nervous system reset</Strong>
                    Downshift from stress, soothe alertness, return to baseline.
                  </OfferingsItem>

                  <OfferingsItem>
                    <Strong>Rest & sleep support</Strong>
                    A slow descent into calm, especially good as an evening session.
                  </OfferingsItem>

                  <OfferingsItem>
                    <Strong>Pleasure + self-trust</Strong>
                    Reconnecting with desire, devotion, confidence, and inner yes.
                  </OfferingsItem>

                  <OfferingsItem>
                    <Strong>Creative renewal</Strong>
                    Spacious attention, imagination, and gentle re-patterning.
                  </OfferingsItem>
                </OfferingsList>
              </OfferingsContainer>
            </Section>

            <Section>
              <H2>Formats</H2>
              <FormatGrid>
                <FormatCard>
                  <FormatTitle>In-person (recommended)</FormatTitle>
                  <FormatText>
                    60–90 minutes. Seated or reclining. Small to medium groups. You provide a quiet room; I
                    bring the session structure and (optionally) sound elements.
                  </FormatText>
                </FormatCard>

                <FormatCard>
                  <FormatTitle>Online</FormatTitle>
                  <FormatText>
                    Great for communities that meet remotely. Simple setup, clear safety cues, and a strong
                    closing to help people return to their day.
                  </FormatText>
                </FormatCard>

                <FormatCard>
                  <FormatTitle>Series</FormatTitle>
                  <FormatText>
                    3–6 sessions over a month or season (themes can evolve: boundaries → confidence → creative
                    expansion, etc.).
                  </FormatText>
                </FormatCard>
              </FormatGrid>
            </Section>

            <Para>
              <Text>
                <H2>Hosting details</H2>
                <p>
                  If you're a wellness centre, museum, or community space and want something your audience will
                  genuinely feel, I'd love to collaborate.
                </p>
                <p>
                  We can co-shape the tone (grounded, dreamy, devotional, more somatic, more poetic) and adapt
                  to your audience (beginners, sensitive nervous systems, creatives, queer community, etc.).
                </p>

                <CTA>
                  <CTAButton href="mailto:spectralcenterhypnosis@gmail.com?subject=Hosting%20a%20Group%20Hypnosis%20Session&body=Hi%20Julia%2C%0A%0AI%27m%20writing%20from%20%5BWellness%20Centre%20Name%5D.%20We%27d%20love%20to%20host%20a%20group%20hypnosis%20session.%0A%0AOur%20ideal%20date(s)%3A%20%5B%5D%0AGroup%20size%3A%20%5B%5D%0ATone%20/Theme%3A%20%5B%5D%0A%0ALooking%20forward%20to%20hearing%20from%20you%2C%0A%5BName%5D">
                    Email me to host
                  </CTAButton>
                  <Small>
                    Or send your website + group size + preferred theme — I'll reply with a simple proposal.
                  </Small>
                </CTA>
              </Text>
              <Img src={img3} alt="group hypnosis image 3" />
            </Para>

            <Divider />

           
          </Body>
        </Wrapper>
      </DeskWrap>
      <Footer />
    </>
  );
};

const DeskWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (min-width: 1000px) {
    flex-direction: row;
  }
`;

const Wrapper = styled.div`
  display: flex;
  padding: 2%;
  flex-direction: column;
  justify-content: space-between;
  height: 90%;
  width: 90%;
  margin: 2%;

  @media (min-width: 1025px) {
    justify-content: flex-start;
    height: 100%;
    padding: 0%;
    margin-right: 10%;
    width: 100%;
  }
`;

const Gif = styled.img`
  max-width: 100px;
  position: absolute;
  margin-left: 200px;
  z-index: 1000;
  top: 5px;
  right: 5px;

  @media (min-width: 1025px) {
    max-width: 150px;
    position: absolute;
    z-index: 1000;
    top: 200px;
    right: 100px;
  }
`;

const Header = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
`;

const Body = styled.div`
  font-family: var(--font-body);
  margin-top: 1%;

  @media (min-width: 1035px) {
    margin-top: 0%;
  }
`;

const H1 = styled.h1`
  font-size: 1.7rem;
  margin-bottom: 0.75rem;
  color: #333;


`;

const H2 = styled.h2`
  font-size: 1.2rem;
  margin: 1.2rem 0 0.6rem;
  color: #333;


`;

const Subhead = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
  max-width: 780px;
  margin-bottom: 16px;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`;

const PrimaryButton = styled.a`
  display: inline-block;
  border: 2px solid #000;
  padding: 10px 14px;
  border-radius: 999px;
  text-decoration: none;
  color: #000;

  &:hover {
    background-color:rgba(255, 119, 200, 0.18);
  }
`;

const Para = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const Text = styled.div`
  flex: 1;
  font-size: 1rem;
  line-height: 1.6;
  color: #333;

  p {
    margin-bottom: 1rem;
  }
`;

const Img = styled.img`
  max-width: 100%;
  border-radius: 1rem;
  margin-top: 2%;

  @media (min-width: 500px) {
    max-width: 220px;
    margin-left: 1%;
    margin-right: 1%;
    border-radius: 5%;
    max-height: fit-content;
  }

  @media (min-width: 1025px) {
    max-width: 320px;
    margin-top: 0;
    margin-left: 2%;
    margin-right: 2%;
  }
`;

const Section = styled.div`
  margin: 1.5rem 0 2rem;
`;

const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;

  @media (min-width: 760px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Card = styled.div`
  border: 2px solid #000;
  border-radius: 10px;
  padding: 16px;


`;

const CardTitle = styled.h3`
  margin: 0 0 6px;
  font-weight: 600;
  color: #000;
`;

const CardText = styled.p`
  margin: 0;
  color: #000;
  line-height: 1.55;
`;

const VenueList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 0.75rem;
`;

const VenueItem = styled.span`
  border: 1px solid #000;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 0.9rem;
  color: #333;
`;

const Note = styled.div`
  border-left: 4px solid #000;
  padding: 10px 12px;
  margin-top: 12px;
  border-radius: 8px;
`;

const OfferingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 1rem 0;
`;

const OfferingsList = styled.ol`
  list-style-type: none;
  padding: 0;
  margin: 0.5rem 0 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 760px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const OfferingsItem = styled.li`
  gap: 0.5rem;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem;
  border: 2px solid #000;
  border-radius: 10px;
  color: var(--ink);

  &:hover {
    background-color:rgba(255, 119, 200, 0.18);
  }
`;

const Strong = styled.h3`
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 6px;
`;

const FormatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;

  @media (min-width: 760px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const FormatCard = styled.div`
  border: 2px solid #000;
  border-radius: 10px;
  padding: 16px;


`;

const FormatTitle = styled.h3`
  margin: 0 0 6px;
  font-weight: 600;
  color: #000;
`;

const FormatText = styled.p`
  margin: 0;
  color: #000;
  line-height: 1.55;
`;

const CTA = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CTAButton = styled.a`
  display: inline-block;
  border: 2px solid #000;
  padding: 12px 14px;
  border-radius: 999px;
  text-decoration: none;
  color: #000;
  width: fit-content;

  &:hover {
    background-color:rgba(255, 119, 200, 0.18);
  }
`;

const Small = styled.p`
  margin: 0;
  font-size: 0.95rem;
  opacity: 0.9;
`;

const Divider = styled.hr`
  border: none;
  border-top: 2px solid #000;
  margin: 28px 0 12px;
`;

export default Group;
